import { MessagesSquare } from "lucide-react";
import type { AppInfo } from "@/shared/apps";

// Where the app sits in the shell: its tabs, "+ New" entries, settings and first steps.
export const app: AppInfo = {
  key: "helpdesk",
  icon: MessagesSquare,
  tabs: [
    { to: "/helpdesk", label: "nav.inbox", perm: ["helpdesk.conversation.read"] },
    { to: "/helpdesk/tickets", label: "nav.tickets", perm: ["helpdesk.ticket.read"] },
  ],
  create: [{ label: "create.ticket", to: "/helpdesk/tickets?new=1", perm: "helpdesk.ticket.create" }],
  settings: { to: "/settings/helpdesk", perm: ["helpdesk.settings.read", "helpdesk.channel.manage"] },
  setup: { channel: "/settings/helpdesk" },
};
